var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoKmDistancia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.15,
    height: 11.852,
    viewBox: "0 0 8.15 11.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location",
    transform: "translate(-79.968 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_250",
    "data-name": "Caminho 250",
    d: "M87.551,2.029A4.022,4.022,0,0,0,84.134,0c-.061,0-.122,0-.182,0a4.022,4.022,0,0,0-3.418,2.029,4.126,4.126,0,0,0-.054,4.077l2.939,5.379,0,.007a.714.714,0,0,0,1.239,0l0-.007,2.939-5.379a4.126,4.126,0,0,0-.054-4.077ZM84.042,5.37A1.667,1.667,0,1,1,85.709,3.7,1.669,1.669,0,0,1,84.042,5.37Z",
    transform: "translate(0 0)",
    fill: "#4663ab"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoKmDistancia);
export default __webpack_public_path__ + "static/media/ico-km-distancia.35f5a112bf609b2914370d92a8ccc06e.svg";
export { ForwardRef as ReactComponent };